export default {
  chinese: 'click idp 中文',
};
